import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import firebase from "firebase/app";
import "firebase/firestore";
import config from "../config";

Vue.config.productionTip = false;

// Disponibilizando a instância do firebase e do firestore no prototype do Vue
Vue.prototype.$firebaseApp = firebase.initializeApp(config.firebaseConfig);
Vue.prototype.$firestore = Vue.prototype.$firebaseApp.firestore();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
